/* =============================================================================
   Kollagen Institut — Desktop editorial mega-menus
   ============================================================================= */
(function () {
  if (window.__kiMegaInit) return;
  window.__kiMegaInit = true;

  function injectCaret(trigger) {
    var oldSvgs = trigger.querySelectorAll('svg');
    for (var s = 0; s < oldSvgs.length; s++) oldSvgs[s].style.display = 'none';
    var caret = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    caret.setAttribute('class', 'ki-mega-caret');
    caret.setAttribute('width', '9');
    caret.setAttribute('height', '6');
    caret.setAttribute('viewBox', '0 0 9 6');
    caret.setAttribute('fill', 'none');
    caret.setAttribute('stroke', 'currentColor');
    caret.setAttribute('stroke-width', '1.3');
    caret.setAttribute('stroke-linecap', 'round');
    caret.setAttribute('stroke-linejoin', 'round');
    caret.setAttribute('aria-hidden', 'true');
    caret.innerHTML = '<path d="M1 1.2L4.5 4.6L8 1.2"/>';
    trigger.appendChild(caret);
  }

  function setupBeratungCta(header) {
    var tpl = document.querySelector('template[data-ki-beratung-cta]');
    if (!tpl) return;
    var nav = header.querySelector('.thb-full-menu');
    if (!nav || nav.querySelector('.kinav__cta')) return;
    nav.appendChild(tpl.content.cloneNode(true));
  }

  // Prefix internal links inside a scope with the active locale root
  // (window.Shopify.routes.root is always "/en/", "/fr/", or "/").
  function localizeLinks(scope) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base === '/') return; // primary locale — nothing to prefix
    var prefix = base.replace(/\/+$/, ''); // "/en"
    var host = window.location.host;
    var anchors = scope.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      var href = a.getAttribute('href') || '';
      var path = '';
      if (href.charAt(0) === '/' && href.charAt(1) !== '/') {
        path = href; // root-relative
      } else if (href.indexOf('http') === 0 && href.indexOf('//' + host) !== -1) {
        path = href.slice(href.indexOf(host) + host.length); // same-host absolute -> path
      } else {
        continue; // external, anchor (#), mailto:, tel:, protocol-relative
      }
      if (path.indexOf(prefix + '/') === 0 || path === prefix) continue; // already localized
      a.setAttribute('href', prefix + path);
    }
  }

  function init() {
    var header = document.getElementById('header');
    if (!header) return;
    setupBeratungCta(header);

    // Localize all internal links to the active locale: the whole header (desktop
    // nav + the just-cloned "Beratung starten" CTA + the mega panels, which live
    // inside #header) and the mobile drawer. localizeLinks is idempotent, so links
    // Shopify already localized (resource links, routes.*) are skipped.
    localizeLinks(header);
    var mobileMenu = document.getElementById('mobile-menu');
    if (mobileMenu) localizeLinks(mobileMenu);

    var panels = document.querySelectorAll('[data-ki-mega]');
    if (!panels.length) return;

    var backdrop = document.querySelector('[data-ki-mega-backdrop]');
    if (backdrop && backdrop.parentElement !== document.body) document.body.appendChild(backdrop);

    var navLinks = header.querySelectorAll('.thb-full-menu > li > a.thb-full-menu--link');
    var HOVER = window.matchMedia('(min-width:1068px) and (hover:hover)').matches;
    var entries = [];
    var closeTimer = null;
    var pinned = null;

    function closeAll() {
      pinned = null;
      entries.forEach(function (e) {
        e.panel.classList.remove('is-open');
        e.trigger.classList.remove('is-active');
        e.trigger.setAttribute('aria-expanded', 'false');
      });
      if (backdrop) backdrop.classList.remove('is-open');
    }
    function openEntry(entry) {
      clearTimeout(closeTimer);
      entries.forEach(function (e) {
        var on = (e === entry);
        e.panel.classList.toggle('is-open', on);
        e.trigger.classList.toggle('is-active', on);
        e.trigger.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      if (backdrop) backdrop.classList.add('is-open');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { if (!pinned) closeAll(); }, 140);
    }

    panels.forEach(function (panel) {
      var labels = (panel.getAttribute('data-ki-trigger-label') || '')
        .split(/[,|]/)
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(Boolean);
      if (!labels.length) return;

      var trigger = null, triggerLi = null;
      for (var i = 0; i < navLinks.length; i++) {
        var navText = (navLinks[i].textContent || '').trim().toLowerCase();
        if (labels.indexOf(navText) !== -1) {
          trigger = navLinks[i];
          triggerLi = trigger.closest('li');
          break;
        }
      }
      if (!trigger || !triggerLi) return;

      trigger.classList.add('ki-mega-trigger');
      triggerLi.classList.add('ki-mega-li');
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      injectCaret(trigger);

      var entry = { panel: panel, trigger: trigger, triggerLi: triggerLi };
      entries.push(entry);

      if (HOVER) {
        [triggerLi, panel].forEach(function (el) {
          el.addEventListener('mouseenter', function () { openEntry(entry); });
          el.addEventListener('mouseleave', scheduleClose);
        });
      }

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (panel.classList.contains('is-open') && pinned === entry) {
          closeAll();
        } else {
          pinned = entry;
          openEntry(entry);
        }
      });
    });

    if (!entries.length) return;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = entries.filter(function (en) { return en.panel.classList.contains('is-open'); })[0];
      if (open) { closeAll(); open.trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      var anyOpen = entries.some(function (en) { return en.panel.classList.contains('is-open'); });
      if (anyOpen && !header.contains(e.target)) closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
